<app-table [data]="users" [isDeletable]="true" [noAdd]="noAdd" [isDeletable]="true" [columns]="columns" [addLink]="'add'" [editLink]="'edit'" (deleteRowEvent)="deleteUser($event)"></app-table>
<router-outlet></router-outlet>